import aosWrapper from './aos-wrapper'
import gsapWrapper from './gsap-wrapper'
import ncsWrapper from './ncs-wrapper'
import pageScroll from './page-scroll'
import viewport from './viewport'

export default {
  aosWrapper,
  gsapWrapper,
  ncsWrapper,
  pageScroll,
  viewport
}
